import React from "react";
import i18n from "i18n";
import styles from "./ItemLocalizationSummary.module.scss";

const ItemLocalizationSummary = ({
  title,
  sku,
  tagsQuantity,
  node,
  location,
}) => {
  return (
    <div className={styles["item-container"]}>
      <div className={styles["item-title"]}>{title} </div>
      <div className={styles["item-sku"]}>{i18n.t("sku").toUpperCase()} {sku}</div>
      <div className={styles["item-bottom"]}>
        <div className={styles["item-quantity"]}>
          {tagsQuantity} {tagsQuantity > 1 ? i18n.t("Tags") : i18n.t("Tag")}
        </div>
        <div className={styles["item-path"]}>
          <div className={styles["item-sucursal"]}>
            <span>{i18n.t("branch.office").toUpperCase()}</span> {node}{" "}
            <span className={styles["item-separator"]}>|</span>
          </div>
          <div className={styles["item-location"]}>{location}</div>
        </div>
      </div>
    </div>
  );
};

export default ItemLocalizationSummary;
